import isotype from "@/assets/isotype.png";
import { Button } from "@/components/ui/button";
import { useApplicationByEdition } from "@/hooks/application-by-edition.hook";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useEditionById } from "@/hooks/edition-by-id.hook";
import { useQuizById } from "@/hooks/quiz-by-id.hook";
import { cn } from "@/lib/utils";
import { currentEditionIdAtom } from "@/store/edition-id.store";
import { Graph } from "iconsax-react";
import { useAtomValue } from "jotai";
import { motion } from "motion/react";
import { FC, HTMLAttributes } from "react";
import { Link } from "react-router-dom";

type QuizResultsReadyBannerProps = HTMLAttributes<HTMLDivElement>;

const QuizResultsReadyBanner: FC<QuizResultsReadyBannerProps> = (props) => {
  const editionId = useAtomValue(currentEditionIdAtom);

  const { data: userProfile } = useCurrentUserProfile();

  const { data: application } = useApplicationByEdition({
    companyId: userProfile?.companyId || "",
    editionId,
  });

  const { data: quiz } = useQuizById({
    companyId: userProfile?.companyId || "",
    applicationQuizId: application?.quizId || "",
  });

  const { data: edition } = useEditionById({
    companyId: userProfile?.companyId || "",
    editionId,
  });

  if (!quiz) {
    return null;
  }

  if (quiz.status === "DELIVERED" && edition?.status !== "FINISHED") {
    return (
      <motion.div
        className={cn(
          "flex flex-col gap-4 rounded-xl bg-[#262452] px-12 py-8 text-white lg:flex-row lg:items-center",
          props.className,
        )}
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <img
          className="hidden shrink-0 lg:block"
          src={isotype}
          width={78}
          height={78}
        />

        <div className="grow">
          <h3 className="mb-2 text-2xl">Revisa tus resultados</h3>

          <p className="text-lg">
            Revisa tu evaluación ahora y descubre el impacto de tu compromiso
            sostenible.
          </p>
        </div>

        <Button variant="secondary" className="self-start lg:self-auto" asChild>
          <Link
            to={`/editions/${application?.edition.id}/quizzes/${quiz.id}/results`}
          >
            <Graph /> Ver resultados
          </Link>
        </Button>
      </motion.div>
    );
  }
};

export default QuizResultsReadyBanner;
